import { createFileRoute } from '@tanstack/react-router'

import { Agent } from '@/widgets/agent'

export const Route = createFileRoute('/_app/agents-hub/risk-scoring/')({
  component: RouteComponent,
})

export const RiskScoringAgentRoute = Route

function RouteComponent() {
  return <Agent agentId="risk-scoring" />
}
